module.exports = __webpack_public_path__ + "media/customizations/lmhh/back-ba40c56e7565666b7e48f94bf081eb4c.jpg";